import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateLifeInsuranceForm } from "web_myplann/Portfolio/Pages/LifeInsuranceCreate/CreateLifeInsuranceForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddLifeInsurancePage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddLifeInsurance.title)}>
			<CreateLifeInsuranceForm />
		</PortfolioAddLayout>
	);
};
